import { render } from "./CreateLabelSetFromCsvModal.vue?vue&type=template&id=6367ec4a&scoped=true"
import script from "./CreateLabelSetFromCsvModal.vue?vue&type=script&lang=js"
export * from "./CreateLabelSetFromCsvModal.vue?vue&type=script&lang=js"

import "./CreateLabelSetFromCsvModal.vue?vue&type=style&index=0&id=6367ec4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6367ec4a"]])

export default __exports__